import { gql } from '@apollo/client';

export const RESOURCE_DAY_LOAD_FIELDS = gql`
    fragment ResourceDayLoadFields on resource_day_load_view {
        resource_id
        delivery_day
        used_weight
        used_cubes
        used_stops
        used_pieces
        committed_orders
        incomplete_orders
    }
`;

// A resource-day with no orders and no holds produces no row and renders 0%.
//
// Scoped by resource_ids rather than client_id: the view carries no client column.
export const QUERY_RESOURCE_DAY_LOAD = gql`
    ${RESOURCE_DAY_LOAD_FIELDS}

    query ResourceDayLoad($resource_ids: [uuid!]!, $start: date!, $end: date!) {
        resource_day_load_view(
            where: { resource_id: { _in: $resource_ids }, delivery_day: { _gte: $start, _lte: $end } }
        ) {
            ...ResourceDayLoadFields
        }
    }
`;
